<template>
  <div class="main">
    <h2 class="is-print-hide title-area">
      <span class="main-title">
        <el-button @click="$router.back()" type="text"><span class="font22">登记记录</span></el-button>
        <span>>登记详情</span>
      </span>
    </h2>
    <el-card>
      <div class="box">
        <div class="item">
          <span class="key">登记单号：</span>
          <span class="key">{{ detail.registrationId }}</span>
        </div>
        <div class="item">
          <span class="key">登记时间：</span>
          <span class="key">{{ detail.registrationTime | formatTime }}</span>
        </div>
        <div class="item"></div>
      </div>
      <div>
        <div class="title">用药人实名信息</div>
        <div class="box">
          <div class="item">
            <span class="key">姓名：</span>
            <span class="value">{{ detail.userName }}</span>
          </div>
          <div class="item">
            <span class="key">身份证号：</span>
            <span class="value">{{ detail.idcardNo }}</span>
          </div>
          <div class="item">
            <span class="key">手机号码：</span>
            <span class="value">{{ detail.userPhone }}</span>
          </div>
        </div>
        <div class="box">
          <div class="item">
            <span class="key">性别：</span>
            <span class="value">{{ detail.sex | userSex }}</span>
          </div>
          <div class="item">
            <span class="key">年龄：</span>
            <span class="value">{{ detail.age }}</span>
          </div>
          <div class="item">
            <span class="key">当前住址：</span>
            <span class="value">{{ detail.address }}</span>
          </div>
        </div>
      </div>
      <div>
        <div class="title">用药人健康信息</div>
        <div class="box">
          <div class="item">
            <span class="key">症状：</span>
            <span class="value">{{ detail.symptoms }}</span>
          </div>
          <div class="item">
            <span class="key">体温：</span>
            <span class="value">{{ detail.bodyTemperature ? detail.bodyTemperature + '℃' : '-' }}</span>
          </div>
          <div class="item">
            <span class="key">健康码状态：</span>
            <span class="value">{{ detail.healthCode }}</span>
          </div>
        </div>
        <div class="box">
          <div class="item">
            <span class="key">核酸检测报告({{ detail.nucleicReportValidity }})：</span>
            <span class="value">{{ detail.nucleicReport }}</span>
          </div>
          <div class="item">
            <span class="key">是否与境外高风险地区人员接触：</span>
            <span class="value">{{ detail.epidemicPeople | status }}</span>
          </div>
          <div class="item">
            <span class="key">是否近期出入境外高风险地区：</span>
            <span class="value">{{ detail.epidemicFocus | status }}</span>
          </div>
        </div>
        <div class="box">
          <div class="item">
            <span class="key">备注：</span>
            <span class="value">{{ detail.remark || '无' }}</span>
          </div>
        </div>
        <div>
          <div class="title">药品信息</div>
          <div class="box" v-for="(item, key) in detail.drugDetailResponse" :key="key">
            <div class="item">
              <span class="key">{{ item.drugName + ' ' }}</span>
              <span class="key">{{ item.drugNum }}</span>
            </div>
            <div class="item"></div>
            <div class="item"></div>
          </div>
          <div class="box">
            <div class="item">
              <span class="key">购买用途：</span>
              <span class="key">{{ detail.purchasePurpose | purchasePurposeStatus }}</span>
            </div>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import dayjs from 'dayjs';
export default {
  data() {
    return {
      id: this.$route.query.id || null,
      detail: {}
    };
  },
  filters: {
    formatTime(val) {
      return dayjs(val).format('YYYY-MM-DD HH:mm:ss');
    },
    userSex(val) {
      return { 0: '女', 1: '男' }[val];
    },
    status(val) {
      return { 0: '否', 1: '是' }[val];
    },
    purchasePurposeStatus(val) {
      return { 0: '本人自用', 1: '备用', 2: '他人使用' }[val] || '--';
    }
  },
  computed: {
    ...mapGetters(['storeList']),
    storeId() {
      const { storeList } = this;
      return Array.isArray(storeList) ? storeList?.[0].id : storeList?.id;
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const { storeId, id } = this;
      return Fetch.getSupervisionIvDetail({
        registrationId: id || null,
        storeId,
        registrationType: 1
      }).then(res => {
        this.detail = res || {};
      });
    }
  }
};
</script>
<style scoped>
.font22 {
  font-size: 22px;
  position: relative;
  top: -1px;
}
.box {
  display: flex;
  justify-content: space-between;
}
.title {
  color: #242424;
  font-size: 20px;
  font-weight: 500;
  line-height: 56px;
}
.item {
  width: 30%;
  text-align: left;
  display: block;
}
.key {
  color: #242424;
  font-size: 14px;
  line-height: 40px;
}
.value {
  color: #666;
  font-size: 14px;
  line-height: 40px;
}
</style>
